<div class="d-flex flex-column h-100 hide-scrollbar">
	<div class="d-flex flex-row mb-3 align-items-center">
		<h1 class="fs-1 fw-bold text-left">{{ titlePage | titlecase }}</h1>
		<app-ui-ready-event class="fw-bold ms-5"></app-ui-ready-event>
	</div>

	<ng-container *ngIf="!!layout && !!layout['sectionLayouts']">
		<ng-container *ngFor="let sectionLayout of layout['sectionLayouts']; trackBy: trackBySectionLayout">
			<div class="shadow p-3 mb-3 mt-1 bg-white rounded"
				 *ngIf="sectionLayout['id'] == 'LYO_SECFILT' && !!(sectionLayout['dataset'])[0] && !!(sectionLayout['dataset'])[0].filterset && !!filterController.filterModels">
				<filter-panel (onFilterClick)="onFilterClick($event)" [filterController]="filterController"
							  [pageReference]="pageId" (onResetFilterClick)="resetFilter($event)"></filter-panel>
			</div>
			<data-table
				*ngIf="sectionLayout['id'] == 'LYO_SECTABLE' && !!(sectionLayout['dataset'])[0] && !!(sectionLayout['dataset'])[0].datas"
				[actionset]="(sectionLayout.actionset[0])"
				(onActionEmit)="actionCatcher($event)" [tableController]="tableController" (onResetSort)="resetSort()"
				[disabledColumns]="disabledColumns"
				class="flex-grow-1 d-flex flex-column"
				[showColumnSettings]="true"
				[pageReference]="pageId"
				[pageId]="pageId" [apiParent]="apiParent" [apiUrl]="apiUrl"
				[reloadData]="reloadData"
				[manualOption]="manualOption"
				[notificationOption]="notificationOption"
			>
			</data-table>

			<div *ngIf="sectionLayout['id'] == 'LYO_FORM'">
				<!--			<form-page-->
				<!--				[apiParent]="apiParent"-->
				<!--				[apiUrl]="apiUrl"-->
				<!--				[id]="'64413'"-->
				<!--				[datasetData]="(sectionLayout['dataset'])[0].datas"-->
				<!--				[actionSet]="(sectionLayout['actionset'])[0]"-->
				<!--			></form-page>-->
				<form-page
					[apiParent]="apiParent"
					[apiUrl]="apiUrl"
					[id]="null"
					[datasetData]="(sectionLayout['dataset'])[0].datas"
					[actionSet]="(sectionLayout['actionset'])[0]"
				></form-page>
			</div>
		</ng-container>

		<action-bar>
			<div leftBtn class="col-auto">
				<custom-btn backNavigation color="primary" [masterFrom]="null"
							[compareTo]="null">{{ 'LABEL_BACK' | translate }}
				</custom-btn>
			</div>
		</action-bar>
	</ng-container>
</div>

